module.exports = __webpack_public_path__ + "img/re_IMG_1232.71f93f91.jpeg";